import { Box, IconButton, Typography } from "@mui/material";
import { ButtonMenu, Link, SynotaLogoSvg, useLayout } from "@synota-io/synota-shared-ui";
import { Close, Menu, PersonOutline, SupervisorAccount } from "@mui/icons-material";
import { ProfileMenu } from "./ProfileMenu";
import { NodeBalance } from "../../modules/reports/components/NodeBalance";
import { useAuth } from "../../api/auth/useAuth";

export const TopbarContent = () => {
  const { isAdmin, self } = useAuth();
  const { isSidebarOpen, toggleSidebar, isMobile } = useLayout();

  const icon = isAdmin ? <SupervisorAccount /> : <PersonOutline />;

  if (isMobile) {
    return (
      <>
        <IconButton onClick={toggleSidebar}>{isSidebarOpen ? <Close /> : <Menu />}</IconButton>
        <Box flexGrow={1} />
        <Link sx={{ lineHeight: 1 }} to="/">
          <SynotaLogoSvg />
        </Link>
        <Box flexGrow={1} />
        <ButtonMenu color="neutral" menu={ProfileMenu}>
          {icon}
        </ButtonMenu>
      </>
    );
  }

  return (
    <>
      <Box flexGrow={1} />
      <Box pr={4}>
        <NodeBalance />
      </Box>
      <ButtonMenu color="neutral" endIcon={icon} menu={ProfileMenu}>
        <Typography
          pr={2}
          color="text.secondary"
          variant="button"
          fontSize="small"
          textTransform="none"
        >
          {self?.email}
        </Typography>
      </ButtonMenu>
    </>
  );
};
